export const theme = {
    colors: {
      background: '#0F0F0F',
      primary: '#D4AF37', // Gold
    //  secondary: '#E0E0E0',
      secondary: '#E30B5C',
      accent: '#00796B',
      text: '#FFFFFF',
    },
    fonts: {
      heading: "'Cinzel', serif",
      body: "'Open Sans', sans-serif",
    },
    spacing: (factor: number) => `${factor * 8}px`,
    decoBorderColor: '#cdcdcd',
  };